.modal {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-y: auto;
}

.paper {
  position: relative;
  top: 4rem;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12);
  padding: 1.5rem 2rem 2rem;
  min-width: 300px;
  max-width: 600px;
  width: 100%;
}

.header {
  display: flex;
}

.headerIcon {
  margin: 0.2rem 0.35rem 0 0;
}

.subTitle {
  font-size: 1.2rem !important;
  font-weight: 300 !important;
  margin-top: 0.25rem !important;
}

.buttons {
  margin-top: 1rem;
}

.button {
  margin-top: 1rem;
  width: 49%;
}

.closeIcon {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.5rem;
  font-size: 3rem !important;
  color: #888;
  cursor: pointer;
}

.form {
  float: left;
  width: 100%;
}

.formSubTitle {
  font-size: 1.2rem !important;
  font-weight: 300 !important;
  margin-top: 0.25rem !important;
}

.imgComponent {
  height: 20vh;
  align-self: center;
}

.imageContainer {
  display: flex;
  width: 760px;
  flex-wrap: wrap;
  justify-content: center;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvZGV2L3NyYy9jYXB0dXJlbGlmZS9yZXBvcy9DYXB0dXJlbGlmZS1hd3MvcHdhL3NyYy9hcHBzL3BvcnRhbC9jb21wb25lbnRzL01vZGFsIiwic291cmNlcyI6WyJjbGFzc2VzLm1vZHVsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFPRjtFQUNFO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQU9GO0VBQ0U7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyIubW9kYWwge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogZmxleC1zdGFydDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIG92ZXJmbG93LXk6IGF1dG87XG59XG5cbi5wYXBlciB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgdG9wOiA0cmVtO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmZmO1xuICBib3JkZXItcmFkaXVzOiA0cHg7XG4gIGJveC1zaGFkb3c6IDBweCAzcHggNXB4IC0xcHggcmdiYSgwLDAsMCwwLjIpLCAwcHggNXB4IDhweCAwcHggcmdiYSgwLDAsMCwwLjE0KSwgMHB4IDFweCAxNHB4IDBweCByZ2JhKDAsMCwwLDAuMTIpO1xuICBwYWRkaW5nOiAxLjVyZW0gMnJlbSAycmVtO1xuICBtaW4td2lkdGg6IDMwMHB4O1xuICBtYXgtd2lkdGg6IDYwMHB4O1xuICB3aWR0aDogMTAwJTtcbn1cblxuLmhlYWRlciB7XG4gIGRpc3BsYXk6IGZsZXg7XG59XG5cbi5oZWFkZXJJY29uIHtcbiAgbWFyZ2luOiAwLjJyZW0gMC4zNXJlbSAwIDA7XG59XG5cbi50aXRsZSB7XG4gIC8vbWFyZ2luLWJvdHRvbTogMXJlbTtcbn1cblxuLnN1YlRpdGxlIHtcbiAgZm9udC1zaXplOiAxLjJyZW0gIWltcG9ydGFudDtcbiAgZm9udC13ZWlnaHQ6IDMwMCAhaW1wb3J0YW50O1xuICBtYXJnaW4tdG9wOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG59XG5cbi5idXR0b25zIHtcbiAgbWFyZ2luLXRvcDogMXJlbTtcbn1cblxuLmJ1dHRvbiB7XG4gIG1hcmdpbi10b3A6IDFyZW07XG4gIHdpZHRoOiA0OSU7XG59XG5cbi5jbG9zZUljb24ge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogMDtcbiAgcmlnaHQ6IDA7XG4gIHBhZGRpbmc6IDAuNXJlbTtcbiAgZm9udC1zaXplOiAzcmVtICFpbXBvcnRhbnQ7XG4gIGNvbG9yOiAjODg4O1xuICBjdXJzb3I6IHBvaW50ZXI7XG59XG5cbi5mb3JtIHtcbiAgZmxvYXQ6IGxlZnQ7XG4gIHdpZHRoOiAxMDAlO1xufVxuXG4uZm9ybVRpdGxlIHtcbiAgLy9tYXJnaW4tYm90dG9tOiAxcmVtO1xufVxuXG4uZm9ybVN1YlRpdGxlIHtcbiAgZm9udC1zaXplOiAxLjJyZW0gIWltcG9ydGFudDtcbiAgZm9udC13ZWlnaHQ6IDMwMCAhaW1wb3J0YW50O1xuICBtYXJnaW4tdG9wOiAwLjI1cmVtICFpbXBvcnRhbnQ7XG59XG5cbi5pbWdDb21wb25lbnQge1xuICBoZWlnaHQ6IDIwdmg7XG4gIGFsaWduLXNlbGY6IGNlbnRlcjtcbn1cblxuLmltYWdlQ29udGFpbmVyIHtcbiAgZGlzcGxheTogZmxleDtcbiAgd2lkdGg6IDc2MHB4O1xuICBmbGV4LXdyYXA6IHdyYXA7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xufVxuIl19 */